<template>
  <section>
    <h1 class="font-semibold">{{ $t('windows.documents.legal.title') }}</h1>
    <hr class="mt-2 mb-2 border-t-1 border-black" />
    <p v-if="$t('windows.documents.legal.firstParagraph')" class="small-p mb-3">{{ $t('windows.documents.legal.firstParagraph') }}</p>

    <h2>{{ $t('windows.documents.legal.edit') }}</h2>
    <hr class="mt-1 mb-2 border-t-1 border-gray-400" />
    <p class="small-p" :class="{ 'mb-3': !$t('windows.documents.legal.thirdParagraph') }">{{ $t('windows.documents.legal.secondParagraph') }}</p>
    <p v-if="$t('windows.documents.legal.thirdParagraph')" class="small-p mb-3">{{ $t('windows.documents.legal.thirdParagraph') }}</p>

    <template v-if="$t('windows.documents.legal.hosting')">
      <h2>{{ $t('windows.documents.legal.hosting') }}</h2>
      <hr class="mt-1 mb-2 border-t-1 border-gray-400" />
      <p v-if="$t('windows.documents.legal.fourthParagraph')" class="small-p mb-3">{{ $t('windows.documents.legal.fourthParagraph') }}</p>
    </template>

    <h2>{{ $t('windows.documents.legal.dirPublication') }}</h2>
    <hr class="mt-1 mb-2 border-t-1 border-gray-400" />
    <p class="small-p mb-3">{{ $t('windows.documents.legal.fifthParagraph') }}</p>

    <h2>{{ $t('windows.documents.legal.contact') }}</h2>
    <hr class="mt-1 mb-2 border-t-1 border-gray-400" />
    <p class="small-p">{{ $t('windows.documents.legal.sixthParagraph') }}</p>
    <p class="small-p mb-3">sobhan.izadi@gmail.com</p>
  </section>
</template>
